import cms from './cms'
import footer from './footer'
import queues from './queues'
import sms from './sms'
import wechat from './wechat'
import panorama from './panorama'

const state = {
  name: '景德镇御窑厂 后台管理程序',
  default: {
    // API 接口地址
    apiBase: process.env.API_ENDPOINT, // eslint-disable-line no-undef
    // 文件上传tusd服务器入口地址
    // tusd: '//127.0.0.1:1080/files/',
    // 会话超时时间，单位分钟
    sessionTimeout: 90,
    // JWT口令牌超时时间，单位分钟
    jwtTimeout: 60,
    notice: {
      warning: {
        duration: 8
      },
      error: {
        duration: 8
      }
    },
    cms,
    queues,
    sms,
    wechat,
    panorama
  },
  footer
}
export default state


// WEBPACK FOOTER //
// ./src/store/config/index.js